import { waitForGtag } from '../../core/helpers.js';

// A referee is coming from a shared link: https://www.astrthelabel.com/pages/referral-shared-link/123456789
// where refid is the referrer customer ID
export default class CustomerReferralShare {
  elements;
  share_url;
  referrer_id;

  constructor () {
    this.elements = {
      sectionContainer: document.querySelector('.referral-share-link'),
    };

    if (window.location.search !== '') {
      // window.location.href = '/account/register';
      this.elements.sectionContainer.innerHTML = `<div class="errors">Incorrect promo URL</div>`;
      return;
    }

    // App Proxy URL
    this.share_url = '/apps/promo/referral-share-link';

    // Extract the referrer ID from the URL
    const url_parts = window.location.pathname.split('/');
    this.referrer_id = Number(url_parts[url_parts.length -1]);
    if (isNaN(this.referrer_id)) {
      this.elements.sectionContainer.innerHTML = `<div class="errors">Incorrect promo URL</div>`;
      return;
    }

    this.loadReferrerData();
  }

  loadReferrerData = async () => {
    waitForGtag(() => {
      gtag('event', 'referral_promo', {
        'step': 'shared-url-page',
      });
    });

    try {
      // https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch
      const response = await fetch(`${this.share_url}${window.theme.customer.app_signature}`, {
        method: 'POST',
        body: JSON.stringify({
          referrer_customer_id: this.referrer_id ?? 0,
          referee_customer_id: window.theme?.customer?.id ?? 0,
          referee_customer_email: window.theme.customer?.email ?? '',
        }),
      });

      if (!response.ok) {
        const error_message = await response.json();
        console.error(error_message);
        throw new Error(error_message.Error);
      }
  
      const json = await response.json();
      console.log('done', json);

      // Customer is logged-out; backend has validated the referrer
      if (json === '') {
        window.location.href = `/account/register?promo=referral&referrer=${this.referrer_id}`;
        return;
      }

      this.elements.sectionContainer.innerHTML = `<div class="form-success">Please use this promo code on checkout: ${json}<br>You will also receive an email with the promo code.</div>`;
      return;
    } catch (error) {
      console.error(error);
      this.elements.sectionContainer.innerHTML = `<div class="errors">An error occured, please try later.<br>Details: ${error.message}</div>`;
    }
  };
}
